import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=f2aca462&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=ts&"
export * from "./Consent.vue?vue&type=script&lang=ts&"
import style0 from "./Consent.vue?vue&type=style&index=0&id=f2aca462&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aca462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
